import React, { useCallback, useMemo } from 'react';
import { AppButton, Box, LinkIcon, RenewalNewBannerIcon } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import Permissions from '@/common/permissions';
import { useHistory } from '@/modules/core';
import { BannerBase } from '@/modules/core/components/Banners';
import { useCurrentOrganization, useHasAccess } from '@/modules/core/hooks';

interface RenewalNewBannerProps {
  endDate?: string | null;
  planYearId?: string;
  onSetConfirmRenewModalVisible: () => void;
}

const RenewalNewBanner = ({ endDate, planYearId, onSetConfirmRenewModalVisible }: RenewalNewBannerProps) => {
  const history = useHistory();
  const hasAccess = useHasAccess([{ permission: Permissions.PLAN_SETUP }]);
  const { defaultOrganizationData } = useCurrentOrganization();

  const isConfirmButtonVisible = useMemo(
    () => hasAccess && (defaultOrganizationData?.type === OrganizationTypes.system
    || defaultOrganizationData?.type === OrganizationTypes.partner
    || defaultOrganizationData?.type === OrganizationTypes.distributor), [defaultOrganizationData?.type, hasAccess]);

  const handleGetStartedClick = useCallback(() => {
    window.open(`${ROUTES.RENEWALS_SETUP_BY_PLAN_YEAR_ID(planYearId)}/${history.location.search}`,
      '_blank'
    );
  }, [history.location.search, planYearId]);
  return (
    <Box>
      <BannerBase
        title="Renew Your Plan for the Upcoming Plan Year"
        description={`Your current plan(s) end on ${endDate ? dayjs(endDate).format(DEFAULT_DATE_FORMAT) : ''}. Renew your plans now to ensure there are no gaps in coverage.`}
        icon={<RenewalNewBannerIcon />}
        testId="renewal-new"
      >
        <Box margin={{top: 'l'}} direction="row" gap="spacing12">
          <AppButton width="160px" onClick={handleGetStartedClick} rightIcon={<LinkIcon size="samll" />}>
            Get Started
          </AppButton>

          {isConfirmButtonVisible && (
            <AppButton width="160px" onClick={onSetConfirmRenewModalVisible} buttonType="secondary">
              Mark as Complete
            </AppButton>
          )}
        </Box>
     
      </BannerBase>
    </Box>
  );
};

export default RenewalNewBanner;
